module.exports = __webpack_public_path__ + "static/img/list-img12.a91eb64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list-img12.png
// module id = Z10O
// module chunks = 0